<template>
  <!--分类详情查看-->
  <el-dialog class="Check"  title="案例编号查看" :visible.sync="dialogVisible" width="60%" >
    <div class="caseMain">
      <div class="caseNumber" v-for="item in caseNumber" :key="item">{{item}}</div>
      <p v-if="caseNumber == null" class="msg">暂无数据</p>
    </div>
    <div class="caseFooter">
      <el-button type="primary" @click="sure">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import bus from './bus'
  export default {
    name: "kindCaseNumber",
    data () {
      return {
        dialogVisible : false,
        caseNumber:[]
      }
    },
    methods:{
      sure(){
        this.dialogVisible = false;
      }
    },
    mounted () {
      bus.$on('kindNumber',msg=>{
      this.dialogVisible = true;
      this.caseNumber = msg;
      })
    }
  }
</script>

<style scoped>
  .caseMain{
    width: 100%;
    height: 400px;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
  }
  .caseNumber{
    width: 15%;
    height: 40px;
    background-color: #E8EAED;
    margin-left: 3%;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    font-size: 18px;
  }
  .caseFooter{
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .caseFooter .el-button{
    height: 40px;
    margin-left: 85%;
  }
</style>

<style>
  .Check .el-dialog__body{
    padding: 0 !important;
  }
  .msg{
    text-align: center;
    height: 100%;
    line-height: 400px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/statistics/kindCaseNumber.vue